module.exports = __webpack_public_path__ + "static/media/next.16558b2f.mp3";